import { render } from "./RecentMeeting.vue?vue&type=template&id=236e8cfe&scoped=true"
import script from "./RecentMeeting.vue?vue&type=script&lang=js"
export * from "./RecentMeeting.vue?vue&type=script&lang=js"

import "./RecentMeeting.vue?vue&type=style&index=0&id=236e8cfe&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236e8cfe"]])

export default __exports__